import { useEffect, useRef } from "react";

/**
 * Runs `callback` after `delayMs` when `deps` change; cancels pending run on cleanup.
 */
export function useDebouncedEffect(
  callback: () => void | Promise<void>,
  deps: unknown[],
  delayMs: number,
  enabled = true
): void {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    if (!enabled) return undefined;
    const timer = window.setTimeout(() => {
      void callbackRef.current();
    }, delayMs);
    return () => window.clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, enabled, delayMs]);
}
